import { useMemo } from 'react'
import { generateLoyaltyPointsCalculatorCruiseOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'

interface Props {
  offer: App.CruiseOffer
  bookingPrice?: number
  calculationType: 'estimate' | 'exact'
  departureId?: string
}

/** NOTE - info modal has been disabled for MVP as not displayed for any other verticals */
function CruiseLoyaltyPoints({ offer, bookingPrice, calculationType, departureId }: Props) {
  const hasSelectedDeparturePricing = !!departureId && bookingPrice != null
  const pointsEarnCalculationOptions = useMemo(
    () => [generateLoyaltyPointsCalculatorCruiseOptions(offer, { bookingPrice, departureId, nights: offer?.duration })],
    [offer, bookingPrice, departureId],
  )

  return <LoyaltyPointsEarn
    offer={offer}
    calculationRequests={pointsEarnCalculationOptions}
    calculationType={calculationType}
    estimateScope={hasSelectedDeparturePricing ? 'selectedOption' : undefined}
  />
}

export default CruiseLoyaltyPoints
